import BASE from './base';
import rgba from './rgba';

export default {
  brand: BASE.brandGold,
  darkBrand: BASE.darkBrandGold,
  primary: BASE.grey03,
  secondary: BASE.stone05,
  third: BASE.stone04,
  fourth: BASE.stone03,
  fifth: BASE.stone02,
  sixth: BASE.stone06,
  base: BASE.stone01,
  background: BASE.stone00,
  trueBackground: BASE.stone00,
  shadow: `0 1px 3px 0 ${rgba(BASE.black, 0.3)}`,

  degree1: '#2cdee8',
  degree0: '#1f5760',

  green: BASE.green,
  orange: BASE.orange,
  red: BASE.red,
  yellow: BASE.yellow,
  blue: BASE.blue,
  black: BASE.black,
  white: BASE.white,
  turquoise: BASE.turquoise,
  flamingo: BASE.flamingo,
  sky: BASE.sky,

  prism01: BASE.prism01,
  prism02: BASE.prism02,
  prism03: BASE.prism03,
  prism04: BASE.prism04,
  prism05: BASE.prism05,
  prism06: BASE.prism06,
  prism07: BASE.prism07,
  prism08: BASE.prism08,
  prism09: BASE.prism09,
  prism10: BASE.prism10,
  prism11: BASE.prism11,
  prism12: BASE.prism12,
  prism13: BASE.prism13,
  prism14: BASE.prism14,
  prism15: BASE.prism15,
  prism16: BASE.prism16,
  prism17: BASE.prism17,
  prism18: BASE.prism18,
  prism19: BASE.prism19,
  prism20: BASE.prism20,
  prism21: BASE.prism21,
  prism22: BASE.prism22,

  prismList: [
    BASE.prism01,
    BASE.prism02,
    BASE.prism03,
    BASE.prism04,
    BASE.prism05,
    BASE.prism06,
    BASE.prism07,
    BASE.prism08,
    BASE.prism09,
    BASE.prism10,
    BASE.prism11,
    BASE.prism12,
    BASE.prism13,
    BASE.prism14,
    BASE.prism15,
    BASE.prism16,
    BASE.prism17,
    BASE.prism18,
    BASE.prism19,
    BASE.prism20,
    BASE.prism21,
    BASE.prism22,
  ],

  slice1: BASE.slice1,
  slice2: BASE.slice2,
  slice3: BASE.slice3,
  slice4: BASE.slice4,
  slice5: BASE.slice5,
  slice6: BASE.slice6,
  slice7: BASE.slice7,
  slice8: BASE.slice8,
  slice9: BASE.slice9,

  sliceList: [
    BASE.slice1,
    BASE.slice2,
    BASE.slice3,
    BASE.slice4,
    BASE.slice5,
    BASE.slice6,
    BASE.slice7,
    BASE.slice8,
    BASE.slice9,
  ],

  secondaryNext: BASE.stone07,
  greenNext: BASE.greenNext,
  deepBlue: BASE.deepBlue,
};
